<!-- TEMPLATE -->
<template>
  <div class="dean-header-search">
    <dean-search-field :value="value" animate>Zoek alles</dean-search-field>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// SVG
import search from '../svg/feather-icons/search.svg';

// COMPONENTS
import deanSearchField from './deanSearchField.vue';

@Component({
  components: {
    deanSearchField
  }
})
export default class deanHeaderSearch extends Vue {
  // PROPS
  @Prop() value!: string;

  search: object = search;
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER SEARCH
.dean-header-search {
  display: block;
  height: 100%;
  padding: 9.5px 0px 9.5px 0px;
}
</style>
